/** biome-ignore-all lint/suspicious/noExplicitAny: <acceptable here> */
import { env } from "@/lib/env";
import { rollbar } from "@/lib/rollbar";

const logAny = (type: "error" | "warn" | "info" | "log" | "debug", ...args: any[]) => {
  if (typeof console !== "undefined" && console[type]) {
    console[type](...args);
  }
  if (env.VITE_APP_ENV !== "development" && rollbar && !["debug", "log"].includes(type)) {
    rollbar[type](...args);
  }
};

export const log = {
  error: (...args: any[]) => logAny("error", ...args),
  warn: (...args: any[]) => logAny("warn", ...args),
  info: (...args: any[]) => logAny("info", ...args),
  log: (...args: any[]) => logAny("log", ...args),
  debug: (...args: any[]) => logAny("debug", ...args),
};
